module.exports = "/_next/static/images/empty-focus-47fe1a81.png";